import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home/home.component';
import { CollectionComponent } from './collection/collection/collection.component';
import { AboutComponent } from './about/about.component';
import { BlogComponent } from './blog/blog/blog.component';
import { PressComponent } from './blog/press/press.component';
import { ContactComponent } from './contact/contact/contact.component';
import { ContactFormComponent } from './contact/contact-form/contact-form.component';
import { PostComponent } from './blog/post/post.component';
import { FairTradeComponent } from './fair-trade/fair-trade.component';
import { PostCollectionComponent } from './collection/post-collection/post-collection.component';
import { DesignersComponent } from './designers/designers.component';
import { PostDesignerComponent } from './designers/post-designer/post-designer.component';
import { QualityComponent } from './quality/quality.component';
import { CustomOrderComponent } from './custom-order/custom-order.component';
import { PhilosophyComponent } from './philosophy/philosophy.component';

//resolve
import { HomeResolve } from './resolves/home.resolve';
import { AboutResolve } from './resolves/about.resolve';
import { CollectionsPage } from './resolves/collections_page.resolve';
import { CollectionTermResolve } from './resolves/collection_term.resolve';
import { PhilosophyResolve } from './resolves/philosophy.resolve';
import { QualityResolve } from './resolves/quality.resolve';
import { FairTradeResolve } from './resolves/fareTrade.resolve';
import { DesignersResolve } from './resolves/designers.resolve';
import { DesignerResolve } from './resolves/designer.resolve';
import { CustomOrderResolve } from './resolves/customOrder.resolve';
import { BlogResolve } from './resolves/blog.resolve';
import { PressResolve } from './resolves/press.resolve';
import { PostResolve } from './resolves/post.resolve';
import { ContactResolve } from './resolves/contact.resolve';
import { ThemesSettings } from './resolves/themes_setting.resolve';
import { Page404Component } from './page404/page404.component';
import { Page404Resolve } from './resolves/page404';

const appRoutes: Routes = [
    { path: '', component: HomeComponent, resolve: { data: HomeResolve, theme: ThemesSettings }},
    { path: 'collections', component: CollectionComponent, resolve: { data: CollectionsPage, theme: ThemesSettings } },
    { path: 'collections/:slug', component: PostCollectionComponent, resolve: { data: CollectionTermResolve, theme: ThemesSettings } },
    { path: 'about', component: AboutComponent, resolve: { data: AboutResolve, theme: ThemesSettings }},
    { path: 'about_us', component: PhilosophyComponent, resolve: { data: PhilosophyResolve, theme: ThemesSettings }},
    { path: 'blog', component: BlogComponent, resolve: { data : BlogResolve, theme: ThemesSettings}},
    { path: 'blog/:slug', component: PostComponent, resolve: { data: PostResolve}},
    { path: 'press', component: PressComponent, resolve: { data: PressResolve, theme: ThemesSettings}},
    { path: 'press/:slug', component: PostComponent, resolve: { data: PostResolve}},
    { path: 'contact', component: ContactComponent, resolve: { data: ContactResolve, theme: ThemesSettings }},
    { path: 'contact-form', component: ContactFormComponent, resolve: { data: ThemesSettings }},
    { path: 'fair-trade', component: FairTradeComponent, resolve: { data: FairTradeResolve, theme: ThemesSettings }},
    { path: 'designers', component: DesignersComponent, resolve: { data: DesignersResolve }},
    { path: 'designers/:slug', component: PostDesignerComponent, resolve: {data: DesignerResolve, theme: ThemesSettings }},
    { path: 'quality', component: QualityComponent, resolve: { data: QualityResolve, theme: ThemesSettings }},
    { path: 'custom-order', component: CustomOrderComponent, resolve: { data: CustomOrderResolve, theme: ThemesSettings }},
    { path: '**', component: Page404Component, resolve: { data: Page404Resolve } }
];
@NgModule({
    imports: [RouterModule.forRoot(appRoutes)],
    exports: [RouterModule]
})

export class AppRoutingModule{

}


// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts